import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
import URI from "urijs";
function UrlMixin(Base) {
  var _class;
  let UrlMixin = (_class = class UrlMixin extends Base {
    constructor() {
      super(...arguments);
      makeObservable(this);
    }
    get hasUrlMixin() {
      return true;
    }
    get uri() {
      if (this.url === undefined) {
        return undefined;
      }
      return new URI(this.url);
    }
  }, _applyDecoratedDescriptor(_class.prototype, "uri", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "uri"), _class.prototype), _class);
  return UrlMixin;
}
(function (_UrlMixin) {
  function isMixedInto(model) {
    return model && model.hasUrlMixin;
  }
  _UrlMixin.isMixedInto = isMixedInto;
})(UrlMixin || (UrlMixin = {}));
export default UrlMixin;